var DATA_HTML_SCROLLS = 'data-html-scrolls';
var DATA_PREVENT_HTML_SCROLL = 'data-prevent-html-scroll';

export { DATA_HTML_SCROLLS, DATA_PREVENT_HTML_SCROLL };
//# sourceMappingURL=scroll.css.js.map
